import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { workflowCenterApi } from '@cloudpivot/api';
import * as WorkflowCenterRouterTypes from '../typings/workflow-center';
import * as WorkflowCenterNS from '../typings/workflow-center';
let WorkflowItemMixin = class WorkflowItemMixin extends Vue {
    constructor() {
        super(...arguments);
        this.tableData = []; // 表格数据
        this.userInfo = {}; // 用户信息
        this.isShowDrawer = false; // 展示人信息
        /**
         * 分页相关数据
        */
        this.pageSize = 20;
        this.curPage = 1;
        this.total = 0;
        this.pageSizeOptions = ['10', '20', '50', '100'];
        /**
         * 列表状态相关
        */
        this.isShowNoData = false; // 内容为空
        this.isShowSearchNoData = false; // 搜索内容为空
        this.isShowTableBox = true; // 是否展示表格
        this.isShowLoadFailBox = false; // 是否展示加载失败
        this.isLoading = true; // 是否显示加载中
        this.isShowLoadAll = false; // 全部加载完成
        this.isShowPagination = false; // 是否显示分页器
        this.scrollY = 0; // 固定表头相关
        this.isCirculateAll = false; // 控制全部已阅置灰
        this.dataHandler = () => { }; // 数据处理函数
        this.searchNumber = -1; // 搜索条数
        this.isShowPager = false;
        this.isShowQueryItem = false; // 是否显示查询条件
        this.queryConditionSource = [];
        this.pageType = '';
        this.showIframeForm = false;
        this.IframeFormUrl = '';
    }
    get isTrident() {
        return window.navigator.userAgent.indexOf('Trident') !== -1;
    }
    get isChinese() {
        return this.$i18n.locale === 'zh';
    }
    /**
     * @desc 请求完毕统一处理方法
     * @param res 请求返回的结果
     * @param type 搜索的类型
    */
    commonHandler(res, type) {
        this.isLoading = false;
        this.isShowQueryItem = false;
        if (res.errcode === 0) {
            this.displayWithSuccess(res.data.content);
            // 展示搜索条数
            if (type === 'search') {
                this.searchNumber = res.data.totalElements;
            }
            else {
                this.searchNumber = -1;
            }
            if (res.data.content.length <= 0) {
                this.displayWithEmpty(type);
                this.isCirculateAll = true;
            }
            else {
                const data = this.dataHandler(res.data.content);
                // 统一处理数据为空的时候展示 '--'
                data.forEach((item) => {
                    const keys = Object.keys(item);
                    keys.forEach((key) => {
                        if (typeof item[key] !== 'boolean') {
                            item[key] = item[key] || '--';
                        }
                    });
                });
                this.tableData = data;
                this.isCirculateAll = false;
                // 展示数据
                this.displayWithData(res.data.totalPages, res.data.totalElements, res.data.content, type);
                const { name } = this.$route;
                let calType = '';
                switch (name) {
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyUnfinishedWorkItem:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.OnlyTable;
                        break;
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyUnReadWorkItem:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.HasBtns;
                        break;
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyFinishedWorkItem:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.HasFilters;
                        break;
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyReadWorkItem:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.HasFilters;
                        break;
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyWorkflow:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.HasTabsAndFilters;
                        break;
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.QueryInstance:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.HasTabsAndFilters;
                        break;
                    case WorkflowCenterRouterTypes.WorkflowCenterRouter.QueryParticipantWorkItem:
                        calType = WorkflowCenterNS.CalculateMaxHeightTypes.HasTabsAndFilters;
                        break;
                    default: break;
                }
                // 表头固定
                // WorkflowCenterHelper.setTableMaxHeight({
                //   vm: this,
                //   type: calType
                // });
                this.setTableMaxHeight();
                // 表格滚动条滚动到顶部
                this.tableScrollToTop();
                // 表格滚动条
                this.tableScrollerHandler();
            }
            this.total = res.data.totalElements;
        }
        else {
            this.displayWithError();
        }
    }
    /**
     * @desc 无数据时展示
     * @params type 搜索或者分页展示不同的图片
    */
    displayWithEmpty(type) {
        this.isShowLoadAll = false;
        this.removeLoadAll();
        this.isShowPagination = false;
        if (type === 'search' || type === 'pageChange') {
            this.isShowNoData = false;
            this.isShowSearchNoData = true;
        }
        else {
            this.isShowNoData = true;
            this.isShowSearchNoData = false;
        }
    }
    /**
     * @desc 有数据时展示
     * @params pages 总页数
    */
    displayWithData(pages, total, data, type) {
        this.tableData = data;
        this.isShowSearchNoData = false;
        this.isShowNoData = false;
        if (pages <= 1) {
            this.appendLoadAll();
            this.isShowPager = true;
            this.isShowLoadAll = true;
            this.isShowPagination = false;
        }
        else {
            this.isShowPagination = true;
            if (data.length < this.pageSize) {
                this.isShowLoadAll = true;
                this.appendLoadAll();
                this.isShowPager = true;
            }
            else {
                this.removeLoadAll();
                this.isShowPager = false;
                this.isShowLoadAll = false;
            }
        }
        if (type) { // 切换pageSize,展示分页器
            this.isShowPagination = true;
        }
    }
    /**
      * @desc 加载错误时展示
    */
    displayWithError() {
        this.isShowTableBox = false;
        this.isShowLoadFailBox = true;
    }
    /**
      * @desc 加载成功时展示
      * @params data 列表数据
    */
    displayWithSuccess(data) {
        this.isShowTableBox = true;
        this.isShowLoadFailBox = false;
        this.tableData = [];
    }
    /**
      * @desc 加载成功时展示
      * @params data 列表数据
    */
    tableScrollToTop() {
        this.$nextTick(() => {
            const Table = document.getElementsByClassName('common-table')[0];
            if (Table.scrollTop && Table.scrollTop > 0) {
                Table.scrollTop = 0;
            }
        });
    }
    /**
      * @desc 展示用户信息侧滑
    */
    showDrawer(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.getUserInfo(id);
            this.isShowDrawer = true;
        });
    }
    /**
      * @desc 点击流程名称打开表单
      * @params obj 当前项数据
    */
    openDetail(obj) {
        obj.vm = this;
        this.$emit('openForm', obj);
    }
    /**
      * @desc 获取用户信息，用于打开用户信息侧滑
      * @params id 用户id
    */
    getUserInfo(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield workflowCenterApi.getUserInfo({ id });
            if (res.errcode === 0) {
                this.userInfo = res.data;
            }
        });
    }
    /**
      * @desc 添加全部加载完成
    */
    appendLoadAll() {
        const { name } = this.$route;
        let hint = '';
        switch (name) {
            case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyUnfinishedWorkItem:
                hint = this.searchNumber < 0 ? this.$t('cloudpivot.flowCenter.pc.showAllTodo') : this.$t('cloudpivot.flowCenter.pc.showAllSearch');
                break;
            case WorkflowCenterRouterTypes.WorkflowCenterRouter.MyUnReadWorkItem:
                hint = this.$t('cloudpivot.flowCenter.pc.showAllToRead');
                break;
            default:
                hint = this.$t('cloudpivot.flowCenter.pc.showAllResult');
                break;
        }
        this.$nextTick(() => {
            const isLoadAllBoxExist = document.querySelectorAll('.data-load-all').length > 0;
            if (isLoadAllBoxExist)
                return;
            const loadAllBox = document.createElement('div');
            loadAllBox.innerHTML = hint;
            loadAllBox.className = 'data-load-all';
            loadAllBox.style.cssText = 'color:rgba(0,0,0,0.45);text-align:center;margin: 40px 0 25px 0';
            document.querySelector('.common-table__tbody-wrap').appendChild(loadAllBox);
        });
    }
    /**
      * @desc 移除全部加载完成
    */
    removeLoadAll() {
        this.$nextTick(() => {
            const loadAllBox = document.querySelector('.data-load-all');
            if (loadAllBox) {
                document.querySelector('.common-table__tbody-wrap').removeChild(loadAllBox);
            }
        });
    }
    /**
     * 设置加载全部文字
    */
    setLoadAllTxt() {
        if (this.isShowPager) {
            this.removeLoadAll();
            this.appendLoadAll();
        }
    }
    /**
     * 设置表格滚动条相关
     */
    tableScrollerHandler() {
        this.$nextTick(() => {
            if (this.isTrident)
                return;
            const table = document.querySelector('div.common-table');
            table.onmouseenter = function () {
                table.className = 'common-table active';
            };
            table.onmouseleave = function () {
                table.className = 'common-table';
            };
        });
    }
    /**
     * 计算表格可视区域的高度
     * 需要减去的高度：
     * content-top：头部
     * actions-btn 操作按钮
     * filter-box：查询条件
     * tab栏
     * 表头
     * 分页器
     * padding table容器的32px内边距
     * 搜索结果高度
     * @tHeadOverflow 部分页面转化成英文版本之后，表头的高度编程两行， 故特殊处理
    */
    setTableMaxHeight() {
        return;
        const { isTrident } = this;
        let diff = 0;
        this.$nextTick(() => {
            const thead = document.querySelector('thead.ant-table-thead');
            if (thead.clientHeight > 39) { // 说明表头已经两行了，需要对偏差值进行累加
                diff += 13;
            }
            const table = this.$refs.table;
            this.scrollY = table.clientHeight - 31 - diff;
            if (isTrident) {
                const doc = document;
                this.scrollY = doc.querySelector('.table').clientHeight;
                doc.querySelector('.ant-table-body').style.maxHeight = doc.querySelector('.table').clientHeight + 'px';
                return;
            }
        });
    }
    toggleQuery() {
        this.isShowQueryItem = !this.isShowQueryItem;
    }
    clear(type) {
        this.queryConditionSource = [];
        if (!type) {
            const queryWorkitem = this.$refs.queryWorkitem;
            queryWorkitem.reset();
        }
        else {
            const tabTable = this.$refs.tabTable;
            const queryWorkitem = tabTable.$refs.queryWorkitem;
            queryWorkitem.reset();
        }
    }
    /**
     * 将查询条件转成组件需要的格式
     * @params data 需要转的数据
     * @params type 有些页面同一个控件但是显示名称不一样
    */
    dataTranslateToFilterCard(data, type) {
        this.pageType = type ? type : '';
        // 将开始结束时间整合
        const deepData = JSON.parse(JSON.stringify(data));
        delete deepData.unitType;
        deepData.time = `${deepData.startTime}~${deepData.endTime}`;
        deepData.originator = deepData.originatorName;
        deepData.participant = deepData.participantName;
        delete deepData.startTime;
        delete deepData.endTime;
        delete deepData.originatorName;
        delete deepData.participantName;
        delete deepData.workflowCode;
        delete deepData.participantUnitType;
        const emptyVals = ['', '~'];
        const vals = [];
        Object.keys(deepData).forEach((key) => {
            if (emptyVals.indexOf(deepData[key]) <= -1) {
                if (key === 'instanceState') {
                    vals.push({
                        name: this.nameTranslator(key, 'zh'),
                        name_i18n: `{"en": "${this.nameTranslator(key, 'en')}"}`,
                        content: this.translateStatusToTxt(deepData[key]),
                        type: -2,
                    });
                }
                else if (key === 'workflowTplName') {
                    vals.push({
                        name: this.nameTranslator(key, 'zh'),
                        name_i18n: `{"en": "${this.nameTranslator(key, 'en')}"}`,
                        content: deepData[key],
                        type: -10,
                    });
                }
                else {
                    vals.push({
                        name: this.nameTranslator(key, 'zh'),
                        name_i18n: `{"en": "${this.nameTranslator(key, 'en')}"}`,
                        content: key === 'participantId' ? deepData[key].split('_$$_')[1] : deepData[key],
                        type: -1,
                    });
                    if (key === 'participantId') {
                        data.participantId = deepData[key].split('_$$_')[0];
                    }
                }
            }
        });
        return vals;
    }
    nameTranslator(key, type) {
        if (!key)
            return '';
        switch (key) {
            case 'workflowName':
                return type === 'en' ? "Workflow Name" : "流程名称";
            case 'time':
                return type === 'en' ? this.timeLabelHandler('en') : this.timeLabelHandler('zh');
            case 'originator':
                return type === 'en' ? "Originator" : "发起人";
            case 'activityName':
                return type === 'en' ? "approvalNode" : "审批节点";
            case 'participant':
            case 'participantId':
                return type === 'en' ? "Resolver" : "处理人";
            case 'instanceState':
                return type === 'en' ? "Workflow Status" : "流程状态";
            case 'workflowTplName':
                return type === 'en' ? "Workflow mode" : "流程模板";
            case 'sequenceNo':
                return type === 'en' ? "Squence No" : "单据号";
            default:
                return '';
        }
    }
    timeLabelHandler(lang) {
        if (!lang)
            return;
        switch (this.pageType) {
            case 'myReadWorkItem':
                return lang === 'en' ? "Receive Time" : "接收时间";
            case 'processing':
                return lang === 'en' ? "Start Time" : "发起时间";
            case 'canceled':
                return lang === 'en' ? "Cancel Time" : "作废时间";
            default:
                return lang === 'en' ? "Action Time" : "处理时间";
        }
    }
    translateStatusToTxt(status) {
        switch (status) {
            case 'PROCESSING':
                return { zh: '进行中', en: 'Processing' };
            case 'COMPLETED':
                return { zh: '已完成', en: 'Completed' };
            case 'CANCELED':
                return { zh: '已作废', en: 'Canceled' };
            case 'EXCEPTION':
                return { zh: '流程异常', en: 'Exception' };
        }
    }
    hideQueryItem() {
        if (!this.isShowQueryItem)
            return;
        this.isShowQueryItem = false;
    }
};
WorkflowItemMixin = tslib_1.__decorate([
    Component
], WorkflowItemMixin);
export default WorkflowItemMixin;
